import React, { useState } from 'react'
import { TextField, Grid, Box, Button } from '@mui/material'
import { array, func } from 'prop-types'
import BaseAutoComplete from '../shared/BaseAutoComplete'
import { Reservas } from '../../services/http'

const SmallTextField = ({ ...props }) => {
  return (
    <TextField sx={{ width: '100%' }} size="small" {...props} color="default" />
  )
}
const FormReserva = ({ onSubmitEnd = () => {}, books }) => {
  const submit = async event => {
    event.preventDefault()
    const data = {
      ...form
    }

    const resp = await Reservas().store(data, {
      notification: true,
      message: 'Sucesso ao reservar obra!'
    })
    onSubmitEnd(resp)
  }

  const [form, setForm] = useState({
    obra_id: null
  })

  return (
    <form onSubmit={submit}>
      <Grid container rowSpacing={1}>
        <Grid item xs={12} sm={12}>
          <Grid container spacing={3}>
            <Grid xs={12} sm={12} item>
              <BaseAutoComplete
                list={books}
                listLabel={'titulo'}
                inputProps={{ label: 'Livro' }}
                Input={SmallTextField}
                onChange={({ id }) => setForm({ ...form, obra_id: id })}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-end'
            }}
          >
            <Button
              sx={{ mt: 2 }}
              type="submit"
              variant="contained"
              color="leitura"
            >
              Reservar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  )
}
FormReserva.propTypes = {
  books: array,
  onSubmitEnd: func
}
export default FormReserva
